import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { startWith, switchMap, takeWhile } from 'rxjs/operators';
import { DataService } from '../../../../../src/app/shared/services/data.service';
import { ResponseData, TeamDetails } from '../../../../../src/app/shared/services/teacher.interface';

@Component({
  selector: 'app-quiz-begin',
  templateUrl: './quiz-begin.component.html',
  styleUrls: ['./quiz-begin.component.scss'],
  animations: [
    trigger('slideUpAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('500ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('10ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 })),
      ]),
    ]),
    // trigger('rotateScale', [
    //   transition(':enter', [
    //     // First animation step (0% to 16% of the animation)
    //     style({ transform: 'scale(0) rotate(0deg)' }),
    //     animate('7s ease', style({ transform: 'scale(0) rotate(0deg)' })),
    //     animate('500ms ease-in-out', style({ transform: 'scale(1.5) rotate(90deg)' })),
    //     animate('500ms ease-in-out', style({ transform: 'scale(1.5) rotate(90deg)' })),
    //     animate('500ms ease-in-out', style({ transform: 'scale(2.5) rotate(180deg)' })),
    //     animate('500ms ease-in-out', style({ transform: 'scale(2.5) rotate(180deg)' })),
    //     animate('500ms ease-in-out', style({ transform: 'scale(4.5) rotate(270deg)' })),
    //     animate('500ms ease-in-out', style({ transform: 'scale(4.5) rotate(270deg)' }))
    //   ])
    // ])
    trigger('rotateScale', [
      transition(':enter', [
        // First animation step (0% to 16% of the animation)
        style({ transform: 'scale(0) rotate(0deg)' }),
        // animate('7s ease', style({ transform: 'scale(0) rotate(0deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(0.2) rotate(90deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(0.2) rotate(90deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(0.4) rotate(180deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(0.4) rotate(180deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(0.6) rotate(270deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(0.6) rotate(270deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(0.8) rotate(360deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(0.8) rotate(360deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(1) rotate(450deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(1) rotate(450deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(1.2) rotate(540deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(1.2) rotate(540deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(1.4) rotate(630deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(1.4) rotate(630deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(1.7) rotate(720deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(1.7) rotate(720deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(2.5) rotate(810deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(2.5) rotate(810deg)' })),

        animate('500ms ease-in-out', style({ transform: 'scale(4.5) rotate(900deg)' })),
        animate('500ms ease-in-out', style({ transform: 'scale(4.5) rotate(900deg)' }))
      ])
    ])
  ],
})
export class QuizBeginComponent implements OnInit {

  sessTeamCode = sessionStorage.getItem('GCTeamCode')
  teamCode = this.sessTeamCode ? this.sessTeamCode : '';
  sessGroup = sessionStorage.getItem('GCGroup');
  group = this.sessGroup ? this.sessGroup : '';
  quizStarted: boolean = false;

  canStartBgAnim = false
  numbers = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
  activeNumber: number | null = null;
  private currentIndex = 0;
  private pollingSubscription!: Subscription;
  private continuePolling = true;
  teamName : string = ''

  constructor(private dataService:DataService,
    private router:Router,
  ){}

  ngOnInit() {
    history.pushState(null, "", window.location.href);
    this.checkStatus()
  }

  checkStatus(){
    this.pollingSubscription = interval(1000)
      .pipe(
        startWith(0),
        switchMap(() => this.dataService.getWaitingTeamStatus(this.group)), 
        takeWhile(() => this.continuePolling)
      )
      .subscribe({
        next: (res: ResponseData<TeamDetails>) => {
          this.teamName = res.data.name
          if (res.data.status === 102) {
            //game ended [status = 102 = Live quiz]
            this.continuePolling = false;
            this.pollingSubscription.unsubscribe();
            if(res.data?.end_time && res.data.remaining_time > 600){
              this.startCountdown();
            } else {
              this.router.navigateByUrl('/quiz')
            }
          } else if(res.data.status === 103){
            //game ended [status = 103 = Completed]
            console.log('status == 103');
            sessionStorage.setItem('GCGroup',res.data.id);
            this.continuePolling = false;
            this.pollingSubscription.unsubscribe();
            this.router.navigateByUrl('/quiz-finished')
          } else if(res.data.status === 104){
            //game ended [status = 103 = Completed]
            console.log('status,104');
            sessionStorage.setItem('GCGroup',res.data.id);
            this.continuePolling = false;
            this.pollingSubscription.unsubscribe();
            this.router.navigateByUrl('/quiz-finished')
          }
          else if(res.data.completed_time){
            // all questions answered by the member/s in a group
            sessionStorage.setItem('GCGroup',res.data.id);
            this.continuePolling = false;
            this.pollingSubscription.unsubscribe();
            this.router.navigateByUrl('/quiz-finished')
          }
        },
        error: (err:HttpErrorResponse) => {
          console.log(err);
          if(err.status == 404){
            //if teacher edit the quiz the response would be 404
            let group = sessionStorage.getItem('GCGroup');
            if(group){
              this.dataService.customSnackBar('Quiz updated','Error','404',5000)
            }
            let queryParams = {id:group}
            this.router.navigate(['/loby'], { queryParams })
          } else {
            this.router.navigate(['/loby'])
          }
        }
      });
  }

  getRemainigTime(endTime:number):number{
    const currentTimeUnix = Math.floor(Date.now() / 1000); 
    return Math.max(0, endTime - currentTimeUnix);
  }

  startCountdown() {
    this.quizStarted = true;
    this.showNumber(this.currentIndex);
    this.canStartBgAnim = true;
    const interval = setInterval(() => {
      this.currentIndex++;

      if (this.currentIndex < this.numbers.length) {
        this.activeNumber = null;
        setTimeout(() => {
          this.showNumber(this.currentIndex);
        }, 100);
      } else {
        clearInterval(interval);
        this.canStartBgAnim = false;
        this.router.navigateByUrl('/quiz')
      }
    }, 1000);
  }

  showNumber(index: number) {
    this.activeNumber = this.numbers[index];
  }

  ngOnDestroy(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }
}
